import { useContext } from 'react';

import { PanelContext, type PanelContextValue } from '../../providers/panel-provider';

export const usePanelContext = (): PanelContextValue => {
	const context = useContext(PanelContext);

	if (!context) {
		throw new Error('usePanelContext must be used within PanelProvider');
	}

	return context;
};
